function digits(value) {
  return String(value == null ? "" : value).replace(/\D/g, "")
}

function lookup(cep, request = window.fetch) {
  const normalized = digits(cep)
  if (normalized.length !== 8) return Promise.resolve(null)

  return request(`https://viacep.com.br/ws/${normalized}/json/`)
    .then((response) => {
      if (!response.ok) throw new Error("Não foi possível consultar o CEP.")
      return response.json()
    })
    .then((address) => {
      if (address.erro) throw new Error("CEP não encontrado.")
      return address
    })
}

function applyAddress(form, address) {
  const fields = {
    logradouro: ".cep-js-rua",
    bairro: ".cep-js-bairro",
    localidade: ".cep-js-cidade",
    uf: ".cep-js-uf"
  }

  Object.keys(fields).forEach((key) => {
    const field = form.querySelector(fields[key])
    if (field && address[key]) field.value = address[key]
  })
}

function setFeedback(form, message, isError) {
  const feedback = form.querySelector("[data-cliente-cep-feedback]")
  if (!feedback) return

  feedback.textContent = message || ""
  feedback.classList.toggle("text-danger", Boolean(isError))
}

const boundFields = new WeakSet()
function initialize(root) {
  root.querySelectorAll("[data-cliente-cep]").forEach((field) => {
    if (boundFields.has(field)) return
    boundFields.add(field)

    const form = field.closest("form") || root
    const search = () => lookup(field.value)
      .then((address) => {
        if (!address) return
        applyAddress(form, address)
        setFeedback(form, "Endereço preenchido pelo CEP.", false)
      })
      .catch((error) => setFeedback(form, error.message, true))

    field.addEventListener("blur", search)

    const street = form.querySelector(".cep-js-rua")
    if (digits(field.value).length === 8 && street && !street.value.trim()) search()
  })
}

module.exports = { digits, lookup, applyAddress, initialize }
